import angular from 'angular';

import orderGasMeterObject from './gasMeterPanelFilter';
import GasMeterPanelService from './GasMeterPanelService';
import GasMeterPanelComponent from './GasMeterPanelComponent';

export default angular
  .module('petroCloud.dashboard.gasMeterPanel', [])
  .filter('orderGasMeterObject', orderGasMeterObject)
  .service('GasMeterPanelService', GasMeterPanelService)
  .component(GasMeterPanelComponent.name, GasMeterPanelComponent)
  .name;
